const getFormData = ({ event, formType, trackingId }) => ({
	event,
	form_type: formType || `[[mapping.form.${trackingId}.type]] >> other`,
	page_type: '[[mapping.pagealias.pageType]]',
	retailer_id: '[[dealerCode.volvo-partner-id]]',
	web_provider: 'ddc',
	state: window.DDC.dataLayer.dealership.stateProvince.toLowerCase()
});

const getPageViewProperties = () => ({
	event: 'volvo_page_view',
	page_type: '[[mapping.pagealias.pageType]]',
	retailer_id: '[[dealerCode.volvo-partner-id]]',
	retailer_name: window.DDC.dataLayer.dealership.dealershipName.toLowerCase(),
	web_provider: 'ddc',
	retailer_state: window.DDC.dataLayer.dealership.stateProvince.toLowerCase()
});

export default {
	events: {
		'ddc.wstagging.first': [
			{
				payload: () => {
					const payloads = [];
					let vehicle = {};
					const pageViewPayload = getPageViewProperties();

					if (window.DDC.dataLayer?.page?.pageInfo?.isVdp) {
						const {
							bodyStyle,
							driveLine,
							engine,
							exteriorColor,
							inventoryType,
							model,
							modelCode,
							modelYear,
							msrp
						} = window.DDC.dataLayer.vehicles[0];

						vehicle = {
							car_status: inventoryType,
							car_model_id: modelCode,
							product_class: bodyStyle,
							powertrain: '',
							car_engine: engine?.slice(0, 2),
							car_model_year: modelYear,
							car_color: exteriorColor
						};

						const itemViewPayload = {
							...pageViewPayload,
							...vehicle
						};

						payloads.push(itemViewPayload, {
							...itemViewPayload,
							event: 'volvo_item_view',
							ecommerce: {
								items: [
									{
										...vehicle,
										item_name: `${model} ${driveLine} ${vehicle.car_engine} ${inventoryType}`,
										car_model: model,
										currency: 'usd',
										item_price: msrp
									}
								]
							}
						});
					} else {
						payloads.push(pageViewPayload);
					}

					return payloads;
				}
			}
		],
		'ddc.link.generic': {
			logic: {
				isTelephonicUrl: true
			},
			payload: {
				event: 'volvo_click_to_call',
				page_type: '[[mapping.pagealias.pageType]]',
				retailer_id: '[[dealerCode.volvo-partner-id]]',
				web_provider: 'ddc',
				state: window.DDC.dataLayer.dealership.stateProvince.toLowerCase()
			}
		},
		'ddc.inventory.filterSearch.click': {
			payload: () => getPageViewProperties()
		},
		widgetUserEvent: [
			{
				logic: ({ eventData: { element, widgetName } = {} }) =>
					widgetName === 'ws-inv-filters' &&
					(element === 'Sort select' ||
						element === 'Clear all button'),
				payload: () => getPageViewProperties()
			} /*
			// perhaps will use this later once we figure out what they want tracked with DR
			, {
				logic: ({ eventData: { eventName, widgetName } = {}}) =>
					widgetName === 'digital-retailing-cox' &&
					eventName === 'DR_PAYMENT_DISPLAY',
				payload: () =>
					getFormData({
						event: 'volvo_form_load',
						formType: 'dr tool'
					})
			}, {
				logic: ({ eventData: { eventName, widgetName } = {}}) =>
					widgetName === 'digital-retailing-cox' &&
					eventName === 'DR_OFFER_SUBMISSION_CLICKED',
				payload: () => getFormData({
					event: 'volvo_form_submit',
					formType: 'dr tool'
				})
			}
			*/
		],
		'ddc.form.onPage': [
			{
				payload: ({ eventData: { trackingId } }) =>
					getFormData({
						event: 'volvo_form_load',
						trackingId
					})
			}
		],
		'ddc.form.confirmation': [
			{
				payload: ({ eventData: { trackingId } }) =>
					getFormData({
						event: 'volvo_form_submit',
						trackingId
					})
			}
		]

		/*
		,
		'ddc.link.clickToCall': {}
		*/
	}
};

/*
bev - battery all electric
-- fuelType: "Fully Electric"
mhev - mild hybrid
phev - plugin hybrid

engine:
I-4 cyl
ER ENGINE
EH Engine
Dual Electric Motor
*/
